import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, IconButton, Sensor, Tooltip, useTheme } from '@streem/ui-react';
import { useRoomSession } from '../../../../context/room_session';
import { useMediaBreakpoint } from '../../../../hooks/use_media_breakpoint';
export function EndCallButton({ host, onClicked = () => { } }) {
    const theme = useTheme();
    const roomSession = useRoomSession();
    const [leavingRoom, setLeavingRoom] = useState(false);
    const [confirmLeave, setConfirmLeave] = useState(false);
    const { isSmallScreen } = useMediaBreakpoint();
    const leaveRoom = async () => {
        if (leavingRoom) {
            return;
        }
        else {
            setLeavingRoom(true);
            await roomSession.leaveRoom();
        }
    };
    const handleConfirmLeave = (value) => {
        setConfirmLeave(value);
    };
    const isEV = !host && !isSmallScreen;
    return (_jsxs(_Fragment, { children: [(isSmallScreen || host) && (_jsx(LeaveCallConfirmationTooltip, { confirmLeave: confirmLeave, setConfirmLeave: handleConfirmLeave, host: host, leavingRoom: leavingRoom, leaveRoom: leaveRoom, onClicked: onClicked, children: confirmLeave ? (_jsx(CancelIconButton, { setConfirmLeave: handleConfirmLeave, theme: theme })) : (_jsx(EndCallIconButton, { confirmLeave: confirmLeave, setConfirmLeave: handleConfirmLeave, host: host, leavingRoom: leavingRoom, isSmallScreen: isSmallScreen, theme: theme })) })), isEV && (_jsx(LeaveCallConfirmationTooltip, { confirmLeave: confirmLeave, setConfirmLeave: handleConfirmLeave, host: host, leavingRoom: leavingRoom, leaveRoom: leaveRoom, onClicked: onClicked, children: _jsx(Button, { "data-testid": 'end-call-button', onClick: () => setConfirmLeave(!confirmLeave), variant: confirmLeave ? 'tertiary' : 'danger', disabled: leavingRoom, style: { minWidth: '127px', marginRight: '0.75rem' }, children: confirmLeave ? 'Cancel' : 'Leave' }) }))] }));
}
const EndCallIconButton = ({ confirmLeave, setConfirmLeave, host, leavingRoom, isSmallScreen, theme, }) => {
    const handleEndCall = () => {
        if (!confirmLeave) {
            setConfirmLeave(true);
        }
    };
    return (_jsx(IconButton, { iconName: "PhoneIconFilled", label: "End Call Button", "data-testid": "end-call-button", onClick: handleEndCall, color: theme.colors.red50, fill: theme.colors.white, background: "red50", size: host ? 'CVLarge' : 'medium', iconSize: host ? '30px' : '20px', disabled: leavingRoom, style: {
            marginLeft: isSmallScreen ? theme.spacing.s : '0px',
            marginRight: isSmallScreen ? theme.spacing.s : '0px',
        } }));
};
const CancelIconButton = ({ setConfirmLeave, theme }) => (_jsx(IconButton, { iconName: "CloseIcon", label: "Cancel", "data-testid": "cancel-button", onClick: () => setConfirmLeave(false), fill: theme.colors.blue50, background: "blue05", style: {
        marginLeft: '8px',
        marginRight: '8px',
        zIndex: 3,
        position: 'relative',
    } }));
const LeaveCallConfirmationTooltip = ({ children, confirmLeave, setConfirmLeave, host, leavingRoom, leaveRoom, onClicked, }) => {
    return (_jsx(Sensor, { onClickOutside: () => setConfirmLeave(false), onEscape: () => setConfirmLeave(false), children: _jsx(Tooltip, { showTooltip: confirmLeave, placement: "top", arrowSize: "0px", color: "grey80", offsetValue: 15, opacity: "0.9", padding: host ? '29vh 16px 16px 16px' : '16px', width: host ? '100vw' : '', height: host ? '100vh' : '', ...(host && { position: 'fixed' }), ...(host && { inset: '0' }), ...(host && { transform: 'none' }), message: _jsx(Button, { "data-testid": 'confirm-end-call-button', onClick: async () => {
                    await leaveRoom();
                    onClicked();
                }, variant: "danger", disabled: leavingRoom, style: host
                    ? {
                        margin: '0 auto',
                        width: '85%',
                    }
                    : {}, children: "Leave Call" }), isModal: true, children: children }) }));
};
//# sourceMappingURL=end_call_button.js.map